export default __webpack_public_path__ + "a7f6c6cc2f0db1718962a0c369cfe78e.png";